module.exports = __webpack_public_path__ + "static/soldier-7e01b368b451ddc053d04151aa9c643d.jpg";